import { InfoItem } from "./InfoItem";
import EmScore from "./EmScore";
import { H3 } from "../Headers/Headings";
import { useTranslations } from "../../contexts/Translation";
import styles from "./Answer.module.css";

type ComponentProps = {
  question: string;
  dontKnows?: number;
  score?: number;
  totalScore?: number | undefined;
  answers: number | undefined;
  candidate: string;
};

const Answer = ({ question, dontKnows, totalScore = 0, score, answers = 0, candidate }: ComponentProps) => {
  const t = useTranslations("questions");

  return (
    <div className={styles.answer}>
      <H3>{t(question, candidate)}</H3>
      <div className={styles.content}>
        <div className={styles.score}>
          <EmScore labelVariant='compact' size={4} score={score ? score : totalScore / (answers === 0 ? 1 : answers)} after={t(`${question}Label`)} />
        </div>
        <div className={styles.details}>
          <InfoItem>{t("resultAnswers", answers)}</InfoItem>
          {(!!dontKnows || dontKnows === 0) && <InfoItem>{t("resultDontKnows", dontKnows)}</InfoItem>}
        </div>
      </div>
    </div>
  );
};

export default Answer;
